<template>
    <!-- Main Slider Start -->
<!--    <div class="ec-main-slider section section-space-pb">-->
<!--        <div class="ec-slider">-->

<!--            <div class="ec-slide-item d-flex slide  cover-image" v-for="(item,index) in sliders?.data">-->

<!--                <img :src="item?.image_pc"-->
<!--                     class="   d-none d-md-block position-absolute" alt="">-->

<!--                <img :src="item?.image_mobile ?? item?.image_pc"-->
<!--                     class="   d-block d-md-none position-absolute" alt="">-->

<!--                <div class="container align-self-center">-->
<!--                    <div class="row">-->
<!--                        <div class="col-sm-12 align-self-center d-flex " :class="{-->
<!--                                'justify-content-center text-center' : item.align == 'center',-->
<!--                                'justify-content-end text-end' : item.align == 'end',-->
<!--                                'justify-content-start text-start' : item.align == 'start',-->
<!--                            }">-->
<!--&lt;!&ndash;                            <div class="ec-slide-content ">&ndash;&gt;-->

<!--&lt;!&ndash;                                <h2 class="ec-slide-stitle">{{ item.name }}</h2>&ndash;&gt;-->
<!--&lt;!&ndash;                                <h1 class="ec-slide-title" v-if="item.sub_title"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :class="{&ndash;&gt;-->
<!--&lt;!&ndash;                                        'text-light' : item.color == 'light',&ndash;&gt;-->
<!--&lt;!&ndash;                                        'text-dark' : item.color == 'dark',&ndash;&gt;-->
<!--&lt;!&ndash;                                    }">&ndash;&gt;-->
<!--&lt;!&ndash;                                    {{ item.sub_title }}&ndash;&gt;-->
<!--&lt;!&ndash;                                </h1>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="ec-slide-disc"&ndash;&gt;-->
<!--&lt;!&ndash;                                     :class="{&ndash;&gt;-->
<!--&lt;!&ndash;                                        'text-light' : item.color == 'light',&ndash;&gt;-->
<!--&lt;!&ndash;                                        'text-dark' : item.color == 'dark',&ndash;&gt;-->
<!--&lt;!&ndash;                                    }">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <p v-if="item.short_description">{{ item.short_description }}</p>&ndash;&gt;-->

<!--&lt;!&ndash;                                    <a :href="item.link" class="btn btn-lg btn-primary" v-if="item.link">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <span>{{ $t('More information') }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <i class="fi-rr-shopping-basket"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </a>&ndash;&gt;-->

<!--&lt;!&ndash;                                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--        </div>-->
<!--    </div>-->

    <div class="custom-main-slider section section-space-pb" style="display: none">
        <div class="custom-slider">

            <div class="custom-slide-item d-flex slide " v-for="(item,index) in sliders?.data">

                <img :src="item?.image_pc"
                     class="   d-none d-md-block " alt="">

                <img :src="item?.image_mobile ?? item?.image_pc"
                     class="   d-block d-md-none " alt="">

            </div>

        </div>
    </div>

    <!--  category Section Start -->
    <section class="section ec-category-section section-space-p">
        <div class="container">
            <div class="row margin-minus-b-15 margin-minus-t-15">
                <div id="ec-cat-slider" class="ec-cat-slider owl-carousel">

                    <div class="ec_cat_content ec_cat_content_2" v-for="section in main?.sections">

                        <router-link
                            :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'section_ids[]': section.id } }"
                            @click="scrollToTop">

                            <div class="ec_cat_inner ec_cat_inner-2">
                                <div class="ec-category-image mb-3">
                                    <img :src="section.icon" class="svg_img" :alt="section.name"/>
                                </div>
                                <div class="ec-category-desc">
                                    <span>{{ section.name }}</span>
                                </div>
                            </div>
                        </router-link>
                    </div>


                </div>
            </div>
        </div>
    </section>
    <!--category Section End -->

    <section class="section ec-about-sec section-space-p mb-5 offer-banners" >
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-sm-12"   v-for="banner in banners">

                        <router-link
                            :to="{name: 'products.show', params: { id: banner.product_id ?? '0' , lang : $i18n.locale  }}"
                            class="banner banner--square cover-image" v-if="banner.product_id != null ">
                            <figure class="banner-effect">
                                <img :src="banner?.image  ?? '/images/spices-jar.jpeg'"
                                     class="img-fluid">
                            </figure>
                        </router-link>

                        <a href="javascript:void(0)"
                            class="banner banner--square cover-image" v-else>
                            <figure class="banner-effect">
                                <img :src="banner?.image  ?? '/images/spices-jar.jpeg'"
                                     class="img-fluid">
                            </figure>
                        </a>

                    </div>

                </div>
            </div>
    </section>
<!--    <section class="section ec-about-sec section-space-p mb-5 offer-banners" >-->
<!--            <div class="container">-->
<!--                <div class="row">-->
<!--                    <div class="col-md-4 col-sm-12"  v-for="product in home?.data?.offers">-->

<!--                        <router-link-->
<!--                            :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"-->
<!--                            class="banner banner&#45;&#45;square   ">-->

<!--                            <figure class="banner-effect">-->
<!--                                <img :src="product?.offer_image  ?? '/images/spices-jar.jpeg'"-->
<!--                                     class="img-fluid">-->
<!--                            </figure>-->
<!--&lt;!&ndash;                            <div class="banner-content">&ndash;&gt;-->
<!--&lt;!&ndash;                                <h3>{{ product.name }}</h3>&ndash;&gt;-->
<!--&lt;!&ndash;                                <p>{{ product.price }} {{ $t('SAR') }}</p>&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--                        </router-link>-->

<!--                    </div>-->

<!--                </div>-->
<!--            </div>-->
<!--    </section>-->

<!--    <section class="section ec-about-sec section-space-p mb-5" v-for="banner in banners">-->
<!--        <div class="container">-->
<!--            <div class="row">-->
<!--                <div class="col-md-12">-->
<!--                    <div class="ec-about-img">-->
<!--                        <img :src="banner?.image"-->
<!--                             :alt="banner?.title" class="rounded rounded-3">-->
<!--                    </div>-->
<!--                </div>-->
<!--                <img src="images/brand-image/banner1.png" class="banner_image_layout banner_image_1 w-100 mb-4" >-->
<!--            </div>-->
<!--        </div>-->
<!--    </section>-->

    <!-- About Start -->
    <section class="section ec-about-sec section-space-p mb-5" v-for="page in home?.data?.pages ?? []">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="ec-about-img">
                        <img :src="page?.image"
                             :alt="page?.title" class="rounded rounded-3">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="ec-about-detail">
                        <h4>{{ page?.title }}</h4>

                        <div v-html="page?.content"></div>
                    </div>
                </div>
                <img src="images/brand-image/banner1.png" class="banner_image_layout banner_image_1 w-100 mb-4" >
            </div>
        </div>
    </section>
    <!-- About End -->

    <!-- Grocery section start -->
    <section class="section ec-grocery-sec section-space-ptb-80 section-space-m position-relative">
        <div class="container">
            <img src="images/brand-image/banner.png" class="banner_image_layout banner_basic_1 w-100 mb-4" >
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="section-title">
                        <h2 class="ec-title">
                            {{ $t('Our latest products') }}
                            <!--                                {{ $t('Products') }}-->
                        </h2>
                        <!--                            <p class="sub-title">Browse The Collection of Top Products</p>-->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="tab-pane fade show active" id="all">
                    <div class="ec-product-slider owl-carousel">


                        <div class="ec-product-content mb-3"
                             v-for="product in products?.data">
                            <div class="ec-product-inner">
                                <div class="ec-pro-image-outer">
                                    <div class="ec-pro-image cover-image">

                                        <router-link
                                            :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                            <img :src="product?.image  ?? '/images/spices-jar.jpeg'"
                                                 class="img-fluid" :alt="product.name">
                                        </router-link>

                                        <span class="flags">
                                            <span class="new" v-if="product?.is_new">{{ $t('New') }}</span>
                                            <span class="hot" v-if="product?.is_hot">{{ $t('Hot') }}</span>
                                        </span>

                                    </div>
                                </div>
                                <div class="ec-pro-content">
                                    <!--                                        <h6 class="ec-pro-stitle">Grain, Breakfast, Fresh</h6>-->

                                    <h5 class="ec-pro-title">{{ product.name }}</h5>
                                    <div class="ec-pro-rat-price">
                                        <span class="ec-price d-flex justify-content-between">

<!--                                            <span class="old-price" v-if="product?.old_price !== null ">{{ product.price }} {{ $t('SAR') }}</span>-->
                                            <span class="new-price">{{ product.price_tax }} {{ $t('SAR') }}</span>

                                            <span class="ec-pro-rating  me-0">

                                                <i v-for="(star, index) in ( product?.avg_rating ?? 0)" :key="index"
                                                   class="ecicon eci-star fill"></i>

                                                <i v-for="(star, index) in 5 - ( product?.avg_rating ?? 0)" :key="index"
                                                   class="ecicon eci-star-o"></i>

                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div class="ec-spe-pro-btn px-0">

                                    <CartButton  v-if="product?.id != null" :product="product" :type="'link'"></CartButton>

                                    <span class="social-btn">

                                            <favoriteIcon
                                                :item="product"
                                                @update:item="product.favorite = $event.favorite"
                                                :theme="'quick-view'">

                                            </favoriteIcon>
                                        <!--                                        <a class="wishlist"><i class="fi-rr-heart"></i></a>-->
                                            <router-link
                                                :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"
                                                class="quick-view">
                                                <i class="fi-rr-eye"></i>
                                            </router-link>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <img src="images/brand-image/banner1.png" class="w-100 mb-4 banner_image_1_rotated" >
            </div>
        </div>
    </section>
    <!-- Grocery section End -->

    <!-- Special Offer Start -->
    <section class="ec-offer-sec section-space-p position-relative">
        <div class="container">
            <img src="images/brand-image/banner.png" class="banner_image_layout banner_basic_1 w-100 mb-4" >
            <div class="row align-items-center">
                <div class="col-md-6 col-sm-12 col-lg-6">
                    <div class="offer-section-title">
                        <h2>
                            <span class="black-text">{{ $t('Special Offers') }}</span>
                            <span class="green-text"> {{ $t('Of The Week!')}}</span>
                        </h2>
                        <p>
                            {{ $t('Follow us daily to get the best offers for all our products. Today we have amazing exclusive offers.')}}
                        </p>
                    </div>
                </div>

                <!--                <div class="col-md-6 col-sm-12 col-lg-6 section-timer">-->
                <!--                    <div class="timer">-->
                <!--                        <div id="countdown">-->
                <!--                            <div id='tiles'></div>-->
                <!--                            <div class="labels">-->
                <!--                                <li>Days</li>-->
                <!--                                <li>Hours</li>-->
                <!--                                <li>Mins</li>-->
                <!--                                <li>Secs</li>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
            <div class="row margin-top">
                <div class=" ec-product-slider-offers owl-carousel">

                    <div class="ec-product-content mb-3"
                         v-for="product in home?.data?.offers">
                        <div class="ec-product-inner">
                            <div class="ec-pro-image-outer">
                                <div class="ec-pro-image cover-image">

                                    <router-link
                                        :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                        <img :src="product?.image  ?? '/images/spices-jar.jpeg'"
                                             class="img-fluid" :alt="product.name">
                                    </router-link>

                                    <!--                                        <span class="flags">-->
                                    <!--                                            <span class="sale">Sale</span>-->
                                    <!--                                        </span>-->

                                    <span class="flags">
                                        <span class="new" v-if="product?.is_new">{{ $t('New') }}</span>
                                        <span class="hot" v-if="product?.is_hot">{{ $t('Hot') }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="ec-pro-content">
                                <!--                                        <h6 class="ec-pro-stitle">Grain, Breakfast, Fresh</h6>-->

                                <h5 class="ec-pro-title">{{ product.name }}</h5>
                                <div class="ec-pro-rat-price">
                                        <span class="ec-price d-flex justify-content-between">
<!--                                            <span class="old-price">$30.00</span>-->
                                            <span class="new-price">{{ product.price_tax }} {{ $t('SAR') }}</span>
                                            <span class="ec-pro-rating  me-0">

                                                <i v-for="(star, index) in ( product?.avg_rating ?? 0)" :key="index"
                                                   class="ecicon eci-star fill"></i>

                                                <i v-for="(star, index) in 5 - ( product?.avg_rating ?? 0)" :key="index"
                                                   class="ecicon eci-star-o"></i>

                                            </span>
                                        </span>
                                </div>
                            </div>
                            <div class="ec-spe-pro-btn px-0">

                                <CartButton :product="product"  v-if="product?.id != null" :type="'link'"></CartButton>

                                <span class="social-btn">

                                            <favoriteIcon
                                                :item="product"
                                                @update:item="product.favorite = $event.favorite"
                                                :theme="'quick-view'">

                                            </favoriteIcon>
                                    <!--                                        <a class="wishlist"><i class="fi-rr-heart"></i></a>-->
                                            <router-link
                                                :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"
                                                class="quick-view">
                                                <i class="fi-rr-eye"></i>
                                            </router-link>
                                    </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </section>
    <!-- Special Offer Start -->

    <!-- Achievement sec Start -->
    <section class="ec-achievement-sec section-space-p section-space-mt">
        <div class="container section-space-mt">
            <div class="shape"></div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="section-title">
                        <h2 class="ec-title">{{ $t('Our numbers') }}</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div id="ec-ach-slider" class="owl-carousel" style="direction: ltr">
                    <div class="main-card card-1">
                        <div class="inner-card">
                            <img src="/images/achievement/1.png" alt="">
                            <h3>{{ main?.statistics?.products }}+</h3>
                            <p>{{ $t('Total Products') }}</p>
                        </div>
                    </div>

                    <div class="main-card card-2">
                        <div class="">
                            <div class="inner-card">
                                <img src="/images/achievement/2.png" alt="">
                                <h3>{{ main?.statistics?.users }}+</h3>
                                <p>{{ $t('Our customers') }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="main-card card-3">
                        <div class="">
                            <div class="inner-card">
                                <img src="/images/achievement/3.png" alt="">
                                <h3>{{ main?.statistics?.orders_shipped }}+</h3>
                                <p>{{ $t('Shipments completed') }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="main-card card-4">
                        <div class="">
                            <div class="inner-card">
                                <img src="/images/achievement/4.png" alt="">
                                <h3>{{ main?.statistics?.products_views }}+</h3>
                                <p>{{ $t('Store visits') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Achievement sec End -->


    <!-- faq sec Start -->
    <section class="ec-faq-sec section-space-p">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="faq-detail">
                        <div class="faq-title">
                            <h3>{{ $t('Frequently Asked Questions') }}</h3>
                            <p class="">
                                {{
                                    $t('We are answering most frequent questions. No worries if you not find exact one. You can find out more by searching or continuing clicking button below or')
                                }}

                                <router-link
                                    :to="{name: 'contact_us.create' ,  params: {  lang : $i18n.locale }}"
                                    class="theme-color text-decoration-underline "> {{ $t('directly contact our support') }}
                                </router-link>
                            </p>
                        </div>

                        <div class="accordion w-100" id="accordion">
                            <div class="accordion-item" v-for="item in home?.data?.faqs ?? []">
                                <h2 class="accordion-header" :id="'heading'+ item.id">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            :data-bs-target="'#collapse'+ item.id" aria-expanded="false"
                                            :aria-controls="'collapse'+ item.id">
                                        {{ item.question }}
                                        <!--                                        <i class="fa-solid fa-angle-down"></i>-->
                                    </button>
                                </h2>
                                <div :id="'collapse'+ item.id" class="accordion-collapse collapse"
                                     :aria-labelledby="'heading'+ item.id"
                                     data-bs-parent="#accordionExample">
                                    <div class="accordion-body" v-html="item?.answer"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="faq-img">
                        <img src="/images/faq/faq.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- faq sec End -->

    <!-- Service section start -->
    <section class="section ec-service-sec section-space-p position-relative">
        <div class="container align-self-center">

            <div class="row">

                <div class="col-lg-4 col-md-12">
                    <div class="main-content-detail">

                        <template v-for="(service , index) in home?.data?.services ?? []">
                            <div class="main-content left  justify-content-end w-100" v-if="index % 2 === 0">
                                <div class="detail-content ">
                                    <h6 class="ec-service-title">
                                        {{ service?.name }}
                                    </h6>
                                    <p class="ec-service-detail">
                                        {{ service?.description }}
                                    </p>
                                </div>
                                <img class="service-img m-0 ms-3" :src="service?.icon" alt="shipping-img">
                            </div>
                        </template>

                    </div>
                </div>

                <div class="col-lg-4 col-md-12">
                    <div class="ec-ser-mid-image">
                        <!--                        <img class="ser-background" src="/images/service/man-box.jpeg" alt="">-->
                        <img class="ser-background rounded" src="/images/man-sa.jpeg" alt="">
                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <div class="main-content-detail">

                        <template v-for="(service , index) in home?.data?.services ?? []">
                            <div class="main-content right justify-content-start w-100" v-if="index % 2 !== 0">
                                <img class="service-img m-0 me-3" :src="service?.icon" alt="shipping-img">
                                <div class="detail-content ">
                                    <h6 class="ec-service-title">{{ service?.name }}</h6>
                                    <p class="ec-service-detail">
                                        {{ service?.description }}
                                    </p>
                                </div>
                            </div>
                        </template>

                    </div>
                </div>
                <img src="images/brand-image/banner1.png" class="w-100 mb-4 banner_image_layout banner_image_3" >
            </div>
        </div>
    </section>
    <!-- Service section End -->

    <!-- ec testmonial Start -->
    <section class="section ec-test-section section-space-ptb-100 section-space-m w-100 position-relative" id="reviews"
    v-if="home?.data?.reviews?.length > 0 ">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="section-title mb-0">
                        <h2 class="ec-bg-title">{{ $t('Client Review')}}</h2>
                        <h2 class="ec-title">{{ $t('Client Review')}}</h2>
                        <p class="sub-title mb-3">
                            {{ $t('What customers said about our products') }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="ec-test-outer">
                    <ul id="ec-testimonial-slider">
                        <li class="ec-test-item" v-for="review in home?.data?.reviews ?? []">
                            <i class="fi-rr-quote-right top"></i>
                            <div class="ec-test-inner">
                                <div class="ec-test-img"><img alt="testimonial" title="testimonial"
                                                              src="/images/testimonial/1.jpg" /></div>
                                <div class="ec-test-content">
                                    <div class="ec-test-desc">
                                        {{ review?.comment }}
                                    </div>
                                    <div class="ec-test-name">{{ review?.user?.name }}</div>
                                    <div class="ec-test-designation">{{ review?.product?.name }}</div>
                                    <div class="ec-test-rating">

                                        <i v-for="(star, index) in ( review?.rating ?? 0)" :key="index"
                                           class="ecicon eci-star fill"></i>

                                        <i v-for="(star, index) in 5 - ( review?.rating ?? 0)" :key="index"
                                           class="ecicon eci-star-o"></i>

                                    </div>
                                </div>
                            </div>
                            <i class="fi-rr-quote-right bottom"></i>
                        </li>

                    </ul>
                </div>
            </div>
            <img src="images/brand-image/banner1.png" class="banner_image_2_rotated banner_image_layout w-100 mb-4" >
        </div>
    </section>
    <!-- ec testmonial end -->


    <ContactUs :main="main"></ContactUs>


</template>

<script>
import CartButton from "../components/cart_item/CartButton.vue"
import ContactUs from "../components/contact_u/contact_us.vue"
import {useHead} from "@vueuse/head";
import favoriteIcon from "./product/favorite-icon.vue";

export default {
    components: {
        favoriteIcon,
        CartButton,
        ContactUs
    },
    name: "home",
    props: ['main'],
    watch: {
        main(newValue) {
            if (newValue !== null) {
                this.runMainSlider();
            }
        }
    },
    data() {
        return {
            sliders: [],
            products: [],
            banners: [],
            home: [],
        }
    },
    async created() {
        // $('.category-slider-2').hide();
        // $('.category-slider').hide();
        await this.getSliders();
        await this.getProducts();
        await this.getHome();
        await this.getBanners();
        this.runHomeSlider();

        useHead({
            title: this.main?.settings?.name,
        })

    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        async getSliders(page = this.$route?.query?.page ?? 1) {

            await axios.get('sliders').then(response => {
                this.sliders = response.data;
            });
        },
        async getHome() {
            await axios.get('home').then(response => {
                this.home = response.data;
            });
        },
        async getProducts(page = this.$route?.query?.page ?? 1) {

            await axios.get('products', {params: {'random': true}}).then(response => {
                this.products = response.data;
            });
        },
        async getBanners(page = this.$route?.query?.page ?? 1) {

            await axios.get('banners').then(response => {
                this.banners = response.data?.data;
            });
        },
        runHomeSlider() {
            let _that = this;
            setTimeout(function () {

                /*--------------------- Product Slider -------------------------------- */
                $('.ec-product-slider').owlCarousel({
                    margin: 30,
                    loop: true,
                    dots: false,
                    rtl: true,
                    nav: false,
                    smartSpeed: 1000,
                    autoplay: true,
                    items: 3,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false
                        },
                        576: {
                            items: 2,
                            nav: false
                        },
                        768: {
                            items: 2,
                            nav: false
                        },
                        992: {
                            items: 3,
                            nav: false
                        },
                        1200: {
                            items: 4,
                            nav: false
                        }
                    }
                });

                $('.ec-product-slider-offers').owlCarousel({
                    margin: 30,
                    loop: true,
                    dots: false,
                    rtl: true,
                    nav: false,
                    smartSpeed: 1000,
                    autoplay: true,
                    items: 3,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false
                        },
                        576: {
                            items: 2,
                            nav: false
                        },
                        768: {
                            items: 2,
                            nav: false
                        },
                        992: {
                            items: 3,
                            nav: false
                        },
                        1200: {
                            items: 4,
                            nav: false
                        }
                    }
                });


                $('#ec-ach-slider').owlCarousel({
                    margin: 30,
                    loop: true,
                    dots: false,
                    nav: false,
                    smartSpeed: 1000,
                    autoplay: true,
                    items: 3,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false
                        },
                        576: {
                            items: 2,
                            nav: false
                        },
                        768: {
                            items: 2,
                            nav: false
                        },
                        992: {
                            items: 3,
                            nav: false
                        },
                        1200: {
                            items: 4,
                            nav: false
                        },
                        1367: {
                            items: 4,
                            nav: false
                        }
                    }
                });
                /*--------------------- Main Slider ---------------------- */
                $('.custom-slider').slick({
                    rows: 1,
                    dots: true,
                    arrows: false,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    /*vertical: true,*/
                    customPaging: function (slider, i) {
                        var thumb = $(slider.$slides[i]).data();
                        return '0' + (i + 1);
                    },

                });
                $('.custom-main-slider').slideDown();

                /*--------------------- Main Slider ---------------------- */
                // $('.ec-slider').slick({
                //     rows: 1,
                //     dots: true,
                //     arrows: false,
                //     infinite: true,
                //     speed: 500,
                //     slidesToShow: 1,
                //     slidesToScroll: 1,
                //     /*vertical: true,*/
                //     customPaging: function (slider, i) {
                //         var thumb = $(slider.$slides[i]).data();
                //         return '0' + (i + 1);
                //     },
                // });

                /*--------------------- Testimonial Slider -------------------------------- */
                $('#ec-testimonial-slider').slick({
                    rows: 1,
                    dots: true,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                    speed: 500,
                    centerPadding: 0,
                    slidesToShow: 1,
                    slidesToScroll: 1
                });

            },350);
        },
        runMainSlider() {
            let _that = this;
            setTimeout(function () {



                /*--------------------- Category Slider -------------------------------- */
                $(' #ec-cat-slider').owlCarousel({
                    margin: 30,
                    loop: true,
                    dots: false,
                    nav: false,
                    smartSpeed: 1000,
                    autoplay: true,
                    items: 3,
                    responsiveClass: true,
                    rtl: true,
                    responsive: {
                        0: {
                            items: 2,
                            nav: false
                        },
                        400: {
                            items: 2,
                            nav: false
                        },
                        576: {
                            items: 3,
                            nav: false
                        },
                        768: {
                            items: 3,
                            nav: false
                        },
                        992: {
                            items: 4,
                            nav: false
                        },
                        1200: {
                            items: 4,
                            nav: false
                        },
                        1367: {
                            items: 4,
                            nav: false
                        },
                        1450: {
                            items: 4,
                            nav: false
                        }
                    }
                });

            }, 500);
        },
    }
}
</script>

<style scoped>

</style>
